import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { HttpClientBase } from "./http-client-base.service";
import { ServicioModel } from "src/app/models/Servicio.model";

@Injectable({
  providedIn: "root",
})
export class ServiciosService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, "servicios/externos"); // La URL base para el servicio de lotes
  }

  getServicios(params) {
    return this.get<any[]>({ endpoint: ``, params });
  }

  crearServicio(data: any) {
    return this.post<any>(data, ``);
  }

  editarServicio(data: any, id: string) {
    return this.put<any>(data, `/${id}`);
  }

  estadoServicio(payload: any, id: string) {
    return this.put<any>(payload, `/${id}/estados`, undefined, true);
  }

  updServicio(payload: any, id: string) {
    return this.put<any>(payload, `/${id}/estados`, undefined, true);
  }

  addArchivo(
    id: string,
    body: any,
    trackLoading: boolean = true,
  ): Observable<any> {
    return this.put<any>(
      body,
      `${id}/configuraciones`,
      undefined,
      trackLoading,
    );
  }

  showServicios(id: string): Observable<HttpResponse<ServicioModel>> {
    return this.get<ServicioModel>({ endpoint: `/${id}` });
  }

  showArchivo(id: string): Observable<any> {
    return this.get<any[]>({ endpoint: `/${id}/files/configuraciones` });
  }

  crearConfigBucket(payload: any, id: string) {
    return this.post<any>(payload, `/${id}/storage/config`, undefined, true);
  }

  showBucket(id: string, idBucket: number): Observable<any> {
    return this.get<any[]>({ endpoint: `/${id}/storage/config/${idBucket}` });
  }

  updBucket(payload: any, id: string, idBucket: number) {
    return this.put<any>(
      payload,
      `/${id}/storage/config/${idBucket}`,
      undefined,
      true,
    );
  }

  deleteBucket(id:string , idBucket:number , trackLoading=true){
      return this.delete<any>(`/${id}/storage/config/${idBucket}`, undefined, undefined, trackLoading);
  }

  crearFlujo(payload: any, id: string) {
    return this.post<any>(payload, `/${id}/flujos`, undefined, true);
  }

  showFlujo(id: string, idBucket: number): Observable<any> {
    return this.get<any[]>({ endpoint: `/${id}/flujos/${idBucket}` });
  }

  updFlujo(payload: any, id: string, idBucket: number) {
    return this.put<any>(payload, `/${id}/flujos/${idBucket}`, undefined, true);
  }

  getListFlujos(id: string) {
    return this.get<any[]>({ endpoint: `/${id}/flujos` });
  }

  deleteFlujo(id: string , idFlujo:number , trackLoading = true ){
    return this.delete<any>(`/${id}/flujos/${idFlujo}`, undefined, undefined, trackLoading);
  }
}
